var roomsKey = "rooms";
var attributeKey = "attributes";

/**
 * ローカルストレージから取得
 */
function getFromStorage(key) {
  return sessionStorage.getItem(key);
}
/**
 * ローカルストレージへの設定
 */
function setToStorage(key, value) {
  sessionStorage.setItem(key, value);
}

class Cache {
  /**
   * 削除します
   */
  remove() {
    sessionStorage.removeItem(roomsKey);
    sessionStorage.removeItem(attributeKey);
  }
  /**
   * テナント情報を取得します
   */
  get rooms() {
    return JSON.parse(getFromStorage(roomsKey));
  }
  set rooms(value) {
    setToStorage(roomsKey, JSON.stringify(value));
  }
  get attributes() {
    return JSON.parse(getFromStorage(attributeKey));
  }
  set attributes(value) {
    setToStorage(attributeKey, JSON.stringify(value));
  }
}
export default Cache;
